import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import digitConverter from "./../../utils/digitConverter";
import WebinarBarchart from "./WebinarBarchart";

const WebinarLevelComponents = ({ batch, data, level, gender, sn }) => {
  return (
    <section className="my-10">
      <div className="divider text-4xl text-slate-500 my-20">
        ওয়েবিনার {digitConverter(batch)}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {/* <WebinarGroupCard batch={batch} gender={gender} level={level} /> */}
        <div className={`p-5 rounded bg-gradient-to-tl from-green-300`}>
          <p className="text-xl">Webinar {batch}</p>

          <br />
          <div className="text-center mb-8">
            <Link
              className="py-3 px-5 rounded bg-green-300"
              to={"/leaderboard" + level + "-webinar-" + batch + "/" + sn}
            >
              {" "}
              <FontAwesomeIcon icon="fa-solid fa-trophy" /> Leaderboard
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5">
          {data.map((exm, index) => (
            <div
              key={index}
              className={`text-right p-2 pb-5 rounded  ${
                exm.Score >= 50
                  ? "bg-green-200"
                  : exm.Score > 0
                  ? "bg-red-200"
                  : " bg-slate-200"
              }`}
            >
              <FontAwesomeIcon
                className="text-sm opacity-30"
                icon="fa-solid fa-circle"
              />
              {level === 2 ? (
                <FontAwesomeIcon
                  className="ml-1 text-sm opacity-30"
                  icon="fa-solid fa-circle"
                />
              ) : (
                ""
              )}{" "}
              <div className=" text-center p-2">
                <p className="text-2xl">{exm.name}</p>
                <p className="text-5xl">{exm.Score}</p>
              </div>
            </div>
          ))}
        </div>
        <WebinarBarchart data={data}></WebinarBarchart>
      </div>

      {/* <p className="text-2xl mt-12 mb-5">আপনার রেজাল্ট</p> */}
    </section>
  );
};

export default WebinarLevelComponents;
